"use client"; // Error boundaries must be Client Components

import { useEffect } from "react";
import { posthog } from "posthog-js";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    posthog.captureException(error);
  }, [error]);

  return (
    // global-error must include html and body tags
    // Note: This bypasses all layouts, so we must use inline styles (no Tailwind/CSS imports)
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link
          href="https://fonts.googleapis.com/css2?family=Geist:wght@400;500;600&display=swap"
          rel="stylesheet"
        />
      </head>
      <body
        style={{
          margin: 0,
          padding: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "'Geist', system-ui, -apple-system, sans-serif",
          backgroundColor: "#fafafa",
          color: "#171717",
        }}
      >
        <div
          style={{
            maxWidth: "420px",
            width: "100%",
            margin: "0 auto",
            padding: "24px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "12px",
              padding: "32px 24px",
              boxShadow:
                "0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)",
              border: "1px solid #e5e5e5",
            }}
          >
            {/* Error icon */}
            <div
              style={{
                width: "48px",
                height: "48px",
                borderRadius: "50%",
                backgroundColor: "#fef2f2",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 16px",
              }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#dc2626"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
            </div>

            <h2
              style={{
                fontSize: "20px",
                fontWeight: 600,
                margin: "0 0 8px",
                color: "#171717",
              }}
            >
              Something went wrong
            </h2>

            <p
              style={{
                fontSize: "14px",
                color: "#737373",
                margin: "0 0 24px",
                lineHeight: 1.5,
              }}
            >
              We encountered an unexpected error. Please try again, or contact
              support if the problem persists.
            </p>

            {error.digest && (
              <p
                style={{
                  fontSize: "12px",
                  color: "#a3a3a3",
                  margin: "0 0 16px",
                  fontFamily: "monospace",
                }}
              >
                Error ID: {error.digest}
              </p>
            )}

            <button
              onClick={() => reset()}
              style={{
                backgroundColor: "#171717",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                padding: "12px 24px",
                fontSize: "14px",
                fontWeight: 500,
                cursor: "pointer",
                width: "100%",
                transition: "background-color 0.15s ease",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.backgroundColor = "#404040")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.backgroundColor = "#171717")
              }
            >
              Try again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
